function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import PropTypes from 'prop-types';
import { unstable_useId as useId, unstable_useForkRef as useForkRef } from '@mui/utils';
import MenuList from '@mui/material/MenuList';
import { forwardRef } from '@mui/x-internals/forwardRef';
import { isHideMenuKey } from "../../utils/keyboardUtils.js";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.js";
import { GridMenu } from "../menu/GridMenu.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.js";
import { gridClasses } from "../../constants/gridClasses.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var GridToolbarExportContainer = forwardRef(function GridToolbarExportContainer(props, ref) {
    var _rootProps_slotProps, _rootProps_slotProps1;
    var children = props.children, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps;
    var buttonProps = slotProps.button || {};
    var tooltipProps = slotProps.tooltip || {};
    var apiRef = useGridApiContext();
    var rootProps = useGridRootProps();
    var exportButtonId = useId();
    var exportMenuId = useId();
    var _React_useState = _sliced_to_array(React.useState(false), 2), open = _React_useState[0], setOpen = _React_useState[1];
    var buttonRef = React.useRef(null);
    var handleRef = useForkRef(ref, buttonRef);
    var handleMenuOpen = function(event) {
        var _buttonProps_onClick;
        setOpen(function(prevOpen) {
            return !prevOpen;
        });
        (_buttonProps_onClick = buttonProps.onClick) === null || _buttonProps_onClick === void 0 ? void 0 : _buttonProps_onClick.call(buttonProps, event);
    };
    var handleMenuClose = function() {
        return setOpen(false);
    };
    var handleListKeyDown = function(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
        }
        if (isHideMenuKey(event.key)) {
            handleMenuClose();
        }
    };
    if (children == null) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(rootProps.slots.baseTooltip, _extends({
                title: apiRef.current.getLocaleText('toolbarExportLabel'),
                enterDelay: 1000
            }, (_rootProps_slotProps = rootProps.slotProps) === null || _rootProps_slotProps === void 0 ? void 0 : _rootProps_slotProps.baseTooltip, tooltipProps, {
                children: /*#__PURE__*/ _jsx(rootProps.slots.baseButton, _extends({
                    size: "small",
                    startIcon: /*#__PURE__*/ _jsx(rootProps.slots.exportIcon, {}),
                    "aria-expanded": open,
                    "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                    "aria-haspopup": "menu",
                    "aria-controls": open ? exportMenuId : undefined,
                    id: exportButtonId
                }, (_rootProps_slotProps1 = rootProps.slotProps) === null || _rootProps_slotProps1 === void 0 ? void 0 : _rootProps_slotProps1.baseButton, buttonProps, {
                    onClick: handleMenuOpen,
                    ref: handleRef,
                    children: apiRef.current.getLocaleText('toolbarExport')
                }))
            })),
            /*#__PURE__*/ _jsx(GridMenu, {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-start",
                children: /*#__PURE__*/ _jsx(MenuList, {
                    id: exportMenuId,
                    className: gridClasses.menuList,
                    "aria-labelledby": exportButtonId,
                    onKeyDown: handleListKeyDown,
                    autoFocusItem: open,
                    children: React.Children.map(children, function(child) {
                        if (!/*#__PURE__*/ React.isValidElement(child)) {
                            return child;
                        }
                        return /*#__PURE__*/ React.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});
process.env.NODE_ENV !== "production" ? GridToolbarExportContainer.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: PropTypes.object
} : void 0;
export { GridToolbarExportContainer };
